document.addEventListener("DOMContentLoaded", function (event) {

    /**
     * Berechnet die Breite eines Elements bis zum Rand des Referenz-Containers oder Viewports.
     * Wird für Image-Column und Content-Overlay verwendet.
     */
    function calculateEdgeWidth(elementRect, refRect, isReversed, isFullwidth) {
        let width = 0;

        if (isFullwidth) {
            if (isReversed) {
                width = elementRect.left + elementRect.width;
            } else {
                width = window.innerWidth - elementRect.left;
            }
        } else {
            if (isReversed) {
                width = elementRect.right - refRect.left;
            } else {
                width = refRect.right - elementRect.left;
            }
        }

        return Math.max(0, Math.min(width, window.innerWidth));
    }

    function adjustImageColumnWidths() {
        const rows = document.querySelectorAll('.ce_rsce_twocolimagewall .ce--imagetextwall--outer .row');

        rows.forEach(row => {
            const imageCol = row.querySelector('.image--col');
            const contentCol = row.querySelector('.content--col');
            const imageInner = imageCol ? imageCol.querySelector('.image-col--inner') : null;
            const darkenOverlayImage = imageCol ? imageCol.querySelector('.darkened-content') : null;
            const darkenOverlayContent = contentCol ? contentCol.querySelector('.darkened-content') : null;

            const containerElement = row.closest('.ce_rsce_twocolimagewall');
            let refElement = document.querySelector('.main-content');

            if (containerElement) {
                const hasContainerClass = Array.from(containerElement.classList).some(cls => cls.startsWith('container'));
                if (hasContainerClass) {
                    const containerRect = containerElement.getBoundingClientRect();
                    const computedStyle = window.getComputedStyle(containerElement);
                    const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
                    const paddingRight = parseFloat(computedStyle.paddingRight) || 0;

                    refElement = {
                        getBoundingClientRect: () => ({
                            left: containerRect.left + paddingLeft,
                            right: containerRect.right - paddingRight,
                            width: containerRect.width - paddingLeft - paddingRight
                        })
                    };
                }
            }

            if (!refElement) {
                console.warn('Reference area (.main-content or specific .ce_rsce_twocolimagewall.container*) not found for row:', row);
                return;
            }
            const refRect = refElement.getBoundingClientRect();

            const isDesktop = window.innerWidth >= 992;
            const isRowReverse = row.classList.contains('flex-row-reverse');

            // Display-Modus aus Klasse ermitteln
            const modeMatch = imageInner ? imageInner.className.match(/display-mode-(\w+)/) : null;
            let effectiveMode = modeMatch ? modeMatch[1] : 'standard';

            // Legacy-Fallback: alte Klassen auf neue Modes mappen
            if (!modeMatch && imageInner) {
                if (imageInner.classList.contains('not-as-bg')) {
                    effectiveMode = 'inline';
                } else if (imageInner.classList.contains('is-row-bg')) {
                    effectiveMode = 'row_bg';
                }
            }

            const isTextOnly = imageInner && imageInner.classList.contains('text-only-mode');
            const treatAsInline = (effectiveMode === 'inline') || isTextOnly;
            const isFullwidth = containerElement && containerElement.classList.contains('is-fullwidth');

            const resetStyles = (el) => {
                 if (el) {
                     el.style.width = '';
                     el.style.maxWidth = '';
                     el.style.left = '';
                     el.style.right = '';
                     if (el === darkenOverlayImage || el === darkenOverlayContent) {
                         el.style.opacity = '';
                     }
                 }
            };

            resetStyles(darkenOverlayImage);
            resetStyles(darkenOverlayContent);
            resetStyles(imageCol);

            if (!isDesktop) return;
            if (!imageCol || !contentCol) return;

            const imageColRect = imageCol.getBoundingClientRect();
            const contentColRect = contentCol.getBoundingClientRect();

            if (!treatAsInline) {
                const targetWidthCol = calculateEdgeWidth(imageColRect, refRect, isRowReverse, isFullwidth);
                imageCol.style.width = `${targetWidthCol}px`;
                imageCol.style.maxWidth = `${targetWidthCol}px`;
            }

            if (darkenOverlayImage) {
                darkenOverlayImage.style.opacity = '1';
            }

            if (darkenOverlayContent) {
                const targetWidthContentOverlay = calculateEdgeWidth(contentColRect, refRect, isRowReverse, isFullwidth);

                if (isRowReverse) {
                    darkenOverlayContent.style.left = '0';
                    darkenOverlayContent.style.right = 'auto';
                } else {
                    darkenOverlayContent.style.right = '0';
                    darkenOverlayContent.style.left = 'auto';
                }

                darkenOverlayContent.style.width = `${targetWidthContentOverlay}px`;
                darkenOverlayContent.style.maxWidth = `${targetWidthContentOverlay}px`;
                darkenOverlayContent.style.opacity = '1';
            }
        });
    }

    /**
     * VenoBox-Lightbox über data-lightbox-group Attribute initialisieren
     * (ersetzt Inline-Scripts aus dem Template)
     */
    function initLightboxes() {
        if (typeof VenoBox === 'undefined') return;

        document.querySelectorAll('[data-lightbox-group]').forEach(function (container) {
            var groupName = container.getAttribute('data-lightbox-group');
            new VenoBox({
                selector: '.' + groupName,
                infinigall: true,
                maxWidth: '95%',
                numeration: true,
                spinner: 'flow',
                initialScale: 0.9,
                transitionSpeed: 200,
                fitView: true,
            });
        });
    }

    function runAdjustments() {
        requestAnimationFrame(adjustImageColumnWidths);
    }

    // Run immediately to prevent flicker
    runAdjustments();

    if (document.readyState === 'complete') {
        runAdjustments();
    } else {
        window.addEventListener('load', runAdjustments);
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(runAdjustments, 100);
    }, { passive: true });

    // Einmaliger verzögerter Nachlauf für spät geladene Inhalte
    setTimeout(runAdjustments, 300);

    // Lightbox initialisieren
    initLightboxes();

}, { passive: true });
